import { Link } from 'react-router-dom';
import { Lock, Compass } from 'lucide-react';
import { Button, EmptyState } from '../components/ui';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export function ForbiddenPage() {
  useDocumentTitle('No access');
  return (
    <div className="mx-auto max-w-lg py-16">
      <EmptyState
        icon={<Lock className="h-6 w-6" />}
        title="You don't have access to this page"
        description="Ask the owner to grant your role the required permission."
        action={
          <Link to="/dashboard">
            <Button variant="secondary">Back to dashboard</Button>
          </Link>
        }
      />
    </div>
  );
}

export function NotFoundPage() {
  useDocumentTitle('Page not found');
  return (
    <div className="mx-auto max-w-lg py-16">
      <EmptyState
        icon={<Compass className="h-6 w-6" />}
        title="Page not found"
        description="The page you're looking for doesn't exist or has moved."
        action={
          <Link to="/dashboard">
            <Button variant="secondary">Back to dashboard</Button>
          </Link>
        }
      />
    </div>
  );
}
